import { render, staticRenderFns } from "./AntFavoriteAction.vue?vue&type=template&id=ae3d3636&scoped=true"
import script from "./AntFavoriteAction.vue?vue&type=script&lang=js"
export * from "./AntFavoriteAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3d3636",
  null
  
)

export default component.exports